import React, { useEffect, useRef, useState } from 'react';
import { useFacility } from '../../context/FacilityContext';
import ImageSubmitForm from '../../Components/Images/ImageSubmitForm/ImageSubmitForm';
import { Alert, Box } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import ImageUploadModal from '../../Components/Images/ImageUploadModal/ImageUploadModal';
import { uploadImagesAndSaveRecords } from './uploadForm';
import DashboardLayout from '../../Components/Dashboard/DashboardLayout/DashboardLayout';
import { listAssignedResidentsFunction } from '../../firebase/functions';

function ImageSubmission() {
  const { facilityId, _ } = useFacility();
  const { userEmail, currentUser } = useAuth();
  const [assignedResidents, setAssignedResidents] = useState([]);

  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [infoAlert, setInfoAlert] = useState('');
  const [errorAlert, setErrorAlert] = useState('');
  const resetAlerts = () => {
    setInfoAlert('');
    setErrorAlert('');
  };

  const formRef = useRef();

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmSubmission = async () => {
    setIsModalOpen(false);
    setIsLoading(true);
    await uploadImagesAndSaveRecords(
      formData,
      images,
      facilityId,
      currentUser.uid,
    );
    formRef.current.resetFormData();
    setFormData(null);
    setImages([]);
    setIsLoading(false);
    setInfoAlert('Images uploaded!');
  };

  const handleFormSubmit = (newFormData) => {
    resetAlerts();
    if (!newFormData.residentId) {
      setErrorAlert('Missing resident!');
      return;
    }
    const { images, ...formDataWithoutImages } = newFormData;
    setFormData(formDataWithoutImages);
    setImages(images);
    setIsModalOpen(true);
  };

  useEffect(() => {
    resetAlerts();
    if (!facilityId) return;
    listAssignedResidentsFunction({
      facilityId: facilityId,
    }).then((result) => {
      setAssignedResidents(result.data.residents);
      if (!result.data.residents?.length > 0)
        setErrorAlert(
          'You do not have any assigned residents in this facility.',
        );
    });
  }, [facilityId]);

  return (
    <div>
      <DashboardLayout facilityId={facilityId} isLoading={isLoading}>
        <Box width={3 / 4}>
          <h2 style={{ marginBottom: '10px' }}>Image Upload</h2>
          {infoAlert && (
            <Alert
              severity="success"
              onClose={() => {
                setInfoAlert('');
              }}
            >
              {infoAlert}
            </Alert>
          )}
          {errorAlert && (
            <Alert
              severity="error"
              onClose={() => {
                setErrorAlert('');
              }}
            >
              {errorAlert}
            </Alert>
          )}
        </Box>
        <Box width={1}>
          <ImageSubmitForm
            onSubmit={handleFormSubmit}
            isPublic={false}
            email={userEmail}
            ref={formRef}
            assignedResidents={assignedResidents}
          />
        </Box>
        <Box width={1}>
          <ImageUploadModal
            open={isModalOpen}
            images={images}
            onClose={handleCloseModal}
            onConfirm={handleConfirmSubmission}
          />
        </Box>
      </DashboardLayout>
    </div>
  );
}

ImageSubmission.propTypes = {};

export default ImageSubmission;
